import { render, staticRenderFns } from "./ArticleDetail.vue?vue&type=template&id=e41abbb0&scoped=true"
import script from "./ArticleDetail.vue?vue&type=script&lang=js"
export * from "./ArticleDetail.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetail.vue?vue&type=style&index=0&id=e41abbb0&prod&lang=scss&scoped=true"
import style1 from "./ArticleDetail.vue?vue&type=style&index=1&id=e41abbb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41abbb0",
  null
  
)

export default component.exports